var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.items),function(type,code){return _c('b-btn',{key:code,attrs:{"variant":_vm.current === code ? 'primary': 'light',"activeClass":"btn-primary","disabled":_vm.disabled},on:{"click":function($event){return _vm.onClick(code)}}},[_vm._v(" "+_vm._s(type)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }